import { createApp } from 'vue'
import App from './App.vue'
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import router from './router'
import '@/assets/reset.css'
import 'reset-css'
import 'vant/es/notify/style'
import 'vant/es/toast/style';
import 'vant/es/dialog/style'

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

const app = createApp(App)
app.use(router)
app.use(pinia)
app.mount('#app')
